import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';
import { FaUserSlash } from 'react-icons/fa';

export default function StudentClassCardItem(props) {
    return (
        <li className='coach-card-class-item'>
            <Link className='coach-card-class-item-link' to={`/academia/turmas/${props.id}`}>
                <p className='name'>{props.name}</p>
                <span className='students'>{props.students} alunos</span>
                <span className='age-group'>{props.ageGroup}</span>
            </Link>
            <button
                type='button'
                className='red'
                onClick={props.unlink}
            >
                <FaUserSlash />
            </button>
        </li>
    )
}